import { PayFundsService } from '@/scripts/services/mdf/pay-funds-service';

export const MDFPayFundsMixin = {
    methods: {
        postPayFunds(accountId, fundRequestId) {
            return new Promise((resolve, reject) => {
                PayFundsService.payFunds(accountId, fundRequestId)
                    .then(() => resolve())
                    .catch(reject);
            })
        },
    }
}